const styles = {
    container: {
      background: "#F5F7FA",
      height: "92vh",
      width: "100%",
      // paddingTop: "2%",
      // paddingRight: "2%",
      // paddingLeft: "2%",
      padding:"0 2%",
      overflowY: "scroll",
    },
    smallBoxContainer: {
      marginTop: "20px",
    },
    // The heading over the meter's latest readings, and each phase's label.
    readingsHead: {
      marginTop: "28px",
      textAlign: "left",
      fontFamily: "manrope",
    },
    readingsTitle: {
      fontSize: "17px",
      fontWeight: 700,
      color: "#363B3F",
    },
    readingsSubtitle: {
      fontSize: "13px",
      color: "#8A8F96",
    },
    // Space above each phase, then a small gap down to its cards.
    phaseLabel: {
      marginTop: "28px",
      marginBottom: "10px",
      textAlign: "left",
      fontFamily: "manrope",
      fontSize: "13px",
      fontWeight: 700,
      letterSpacing: "0.04em",
      textTransform: "uppercase",
      color: "#2050FF",
    },
    firstPhaseLabel: {
      marginTop: "16px",
    },
    chartContainer: {
      width: "100%",
      height: "317px",
      background: "#FFFFFF",
      borderRadius: "14px",
      marginTop: "2%",
      padding: "24px",
    },
    smallPieContainer: {
      display: "flex",
      alignItems: "center",
      gap: "10px",
    },
  };
  
  export default styles;
  